
/**
 * Segmentation Helper
 */

define(function(require, exports, module) {
    'use strict';

    var _ = require('underscore');
    var user = require('user');
    var storage = require('util/storage.util');

    module.exports = {

        /**
         * Check if user profile matches one in coma-separated profile list
         * @param {String} urlTemplates
         * @returns {boolean}
         */
        isProfileAllowed: function(urlTemplates) {
            const userModelInStorage = storage.session.getItem('userModel');
            const userUrlTemplates = user.get('urlTemplates') || userModelInStorage.urlTemplates || [];

            if (_.isEmpty(urlTemplates) || !userUrlTemplates.length) {
                return false;
            }

            const commonUrlTemplates = _.intersection(
                urlTemplates.split(',').map(template => template.trim()),
                userUrlTemplates.map(template => template.trim())
            );

            return Boolean(commonUrlTemplates.length);
        }

    };

});
